/*
 * collection-swatch-filter.js
 * When a colour filter is active on a collection page, each product card:
 *   - marks the matching colour swatch as active
 *   - swaps the card's main image to that colour's variant image
 * Multiple colours selected => alternates across the grid, always landing on a
 * colour the product actually has.
 *
 * Self-contained: relies only on the data-* attributes your card swatches
 * already output (data-value / data-image / data-position) with the inline
 * variants JSON as a fallback. No dependency on the theme's swatch JS.
 */
(function () {
  if (window.__glozinSwatchFilterInit) return;
  window.__glozinSwatchFilterInit = true;

  var CARD = '.product-item';
  var SWATCH = '.product__color-swatches--js[data-value]';
  var IMG = 'img.product-image.first-image';
  var IMG_WIDTH = 640; // rendered card image width to request from the CDN

  function norm(s) { return (s == null ? '' : String(s)).trim().toLowerCase(); }

  // Add/replace the Shopify CDN width param so we don't blow up the 50px swatch thumb.
  function withWidth(u, w) {
    try {
      var url = new URL(u, window.location.origin);
      url.searchParams.set('width', w);
      return url.href;
    } catch (e) { return u; }
  }

  // Colour values from the URL filter params, kept only if they match a real
  // swatch on the page (so size/other filters are ignored automatically).
  function activeFilterColors() {
    var params = new URLSearchParams(window.location.search);
    var raw = [];
    params.forEach(function (v, k) { if (k.indexOf('filter.') === 0) raw.push(norm(v)); });
    if (!raw.length) return [];

    var present = Object.create(null);
    document.querySelectorAll(CARD + ' ' + SWATCH).forEach(function (el) {
      present[norm(el.getAttribute('data-value'))] = true;
    });

    var seen = Object.create(null), out = [];
    raw.forEach(function (v) {
      if (present[v] && !seen[v]) { seen[v] = true; out.push(v); }
    });
    return out;
  }

  function cardImageEl(card) {
    return card.querySelector(IMG) ||
           card.querySelector('.product__media img') ||
           card.querySelector('.product-item__inner img');
  }

  // Primary: the swatch's own data-image. Fallback: match colour in variants JSON.
  function swatchImage(swatch, card) {
    var di = swatch.getAttribute('data-image');
    if (di) return di;
    try {
      var s = card.querySelector('variant-radios script[type="application/json"]');
      if (!s) return null;
      var variants = JSON.parse(s.textContent);
      var key = 'option' + (swatch.getAttribute('data-position') || '1');
      var want = norm(swatch.getAttribute('data-value'));
      for (var i = 0; i < variants.length; i++) {
        if (norm(variants[i][key]) === want) {
          var v = variants[i];
          if (v.featured_image && v.featured_image.src) return v.featured_image.src;
          if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
            return v.featured_media.preview_image.src;
          }
          return null;
        }
      }
    } catch (e) {}
    return null;
  }

  function setImage(img, url) {
    if (!img || !url) return;
    if (!img.dataset.origSrc) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
    }
    var big = withWidth(url, IMG_WIDTH);
    img.setAttribute('src', big);
    img.setAttribute('srcset', big);
    if ('src' in img.dataset) img.dataset.src = big;       // lazyload hooks
    if ('srcset' in img.dataset) img.dataset.srcset = big;
    img.classList.remove('lazyload', 'lazypreload', 'lazyloading');
    img.classList.add('lazyloaded');
  }

  function restoreImage(img) {
    if (!img || !img.dataset.origSrc) return;
    img.setAttribute('src', img.dataset.origSrc);
    if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
  }

  function apply() {
    var isCollection = document.querySelector('#CollectionSidebar') ||
                       /\/collections\//.test(window.location.pathname);
    if (!isCollection) return;

    var colors = activeFilterColors();
    var cards = document.querySelectorAll(CARD);
    var rot = 0; // rotating index for the alternate behaviour

    cards.forEach(function (card) {
      var swatches = Array.prototype.slice.call(card.querySelectorAll(SWATCH));
      if (!swatches.length) return;
      var img = cardImageEl(card);

      if (!colors.length) { restoreImage(img); return; } // filter cleared

      var map = Object.create(null);
      swatches.forEach(function (sw) { map[norm(sw.getAttribute('data-value'))] = sw; });

      // Rotate through the active colours, land on one this product has.
      var chosen = null;
      for (var i = 0; i < colors.length; i++) {
        var c = colors[(rot + i) % colors.length];
        if (map[c]) { chosen = c; break; }
      }
      if (!chosen) return;
      rot++;

      var sw = map[chosen];
      swatches.forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      sw.classList.remove('opacity-0', 'hidden'); // reveal if it was in the "+N" overflow

      var url = swatchImage(sw, card);
      if (url) setImage(img, url);
    });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }

  function boot() {
    apply();
    var root = document.querySelector('main') || document.getElementById('MainContent') || document.body;
    try {
      // childList only (not attributes) so our own src/class edits don't re-trigger us.
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(root, { childList: true, subtree: true });
    } catch (e) {}
    window.addEventListener('popstate', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();